/**
 * Configurazione runtime del frontend.
 * La baseURL arriva SOLO da qui: niente URL hardcoded nei servizi.
 * - .env        -> produzione (committato)
 * - .env.local  -> override locale/staging (ignorato da git)
 * Vue CLI legge le VUE_APP_* all'avvio di serve/build: dopo una modifica riavviare.
 */
const raw = process.env.VUE_APP_API_URL || 'https://gestionalesimba.it';

export const API_BASE_URL = raw.replace(/\/+$/, '') + '/';
